import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from "@angular/forms";
import { validationmethod } from "src/app/shared/common/validationmethod";
import { ErrorMessages } from 'src/app/shared/common/errormessages';
import { MatDialogRef } from "@angular/material/dialog";
import { TransactionScreenCreatorMessageComponent } from 'src/app/user/transaction-screen-creator-message/transaction-screen-creator-message.component';
import { MatDialog } from '@angular/material/dialog';
import { LocalStorageSettingsService } from 'src/app/shared/services/local-storage-settings.service';

@Component({
    selector: 'app-transaction-screen-creator-delete',
    templateUrl: './transaction-screen-creator-delete.component.html',
    styleUrls: ['./transaction-screen-creator-delete.component.scss'],
    standalone: false
})
export class TransactionScreenCreatorDeleteComponent implements OnInit {

  formValid: UntypedFormGroup;

  deleteScreenName = { screenName: "" };

  validation_messages;
  backgroundColorButton: any;


  constructor(private validation: validationmethod, private errormessages: ErrorMessages,private localStorageSettings: LocalStorageSettingsService,private dialogref: MatDialogRef<TransactionScreenCreatorDeleteComponent>, private dialog: MatDialog) {

    //messages for validations
    this.validation_messages = this.errormessages.deleteScreenNameMessages;

  }

  ngOnInit() {

    this.formValidations();
 this.backgroundColorButton = this.localStorageSettings.getSettings("ColorA");
  }

  formValidations() {
    // form validations
    this.formValid = new UntypedFormGroup({
      screenName: new UntypedFormControl("", [Validators.required,
      this.validation.noWhitespaceValidator, Validators.pattern('^[a-z]+$'), Validators.maxLength(64)])
    });

  }

  delete() {

    console.log("delete");

    // checking the form is valid or not while insert
    if (!this.formValid.valid) {

      // displaying validation messages
      this.validation.validateAllFormFields(this.formValid);

      this.validation.getvalidationmessage();

    }

    else {

      let width = "40%";

      let dialogRef = this.dialog.open(TransactionScreenCreatorMessageComponent, {
        maxWidth: '100vw',
        width: width,
        data: { screenName: this.deleteScreenName.screenName },
        disableClose: true
      });

      // subcribe the popup after close
      dialogRef.afterClosed().subscribe(result => {

        console.log(result);

        let empty = { "screenName": "" };

        this.deleteScreenName = empty;

        this.formValid.reset();

        this.formValidations();

      });

    }

  }

  cancel() {

    console.log("cancel");

    this.dialogref.close();

  }

}
